import GuidedCaptureOptionsStore from './schema/GuidedCaptureOptionsStore';
import { createStore } from 'satcheljs';
import '../mutators/discardGuidedCaptureOptions';
import '../mutators/setAutoCollectionEnabledOption';

const defaultStore: GuidedCaptureOptionsStore = {
    autoCollectionEnabled: null,
};

export const getStore = createStore('guidedCaptureOptionsStore', defaultStore);
export default getStore;
